import "@testing-library/jest-dom";
import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import FieldsStep from "./FieldsStep";

const mockUpdateField = jest.fn();

const mockColumn = (id: string, name: string) => ({
  id,
  column_name: name,
  display_name: name,
  data_type: "NVARCHAR(255)",
  is_primary_key: false,
  is_foreign_key: false,
});

const mockSelected = (id: string, name: string, isUserIdentifier: boolean) => ({
  id,
  columnId: id,
  column: mockColumn(id, name),
  tableId: "t1",
  tableName: "People",
  tableAlias: null,
  displayLabel: name,
  isVisible: true,
  isEditable: true,
  isLinkField: false,
  isUserIdentifier,
  sortOrder: 0,
});

let mockSelectedFields: ReturnType<typeof mockSelected>[] = [];

jest.mock("../ViewBuilderContext", () => ({
  useViewBuilderContext: () => ({
    state: {
      focusTableId: "t1",
      focusTable: {
        id: "t1",
        table_name: "people",
        display_name: "People",
        columns: [
          mockColumn("c-email", "email"),
          mockColumn("c-work", "work_email"),
        ],
      },
      selectedFields: mockSelectedFields,
      selectedJoins: [],
    },
    toggleField: jest.fn(),
    reorderFields: jest.fn(),
    updateField: mockUpdateField,
    isFieldSelected: () => true,
    getFieldError: () => undefined,
  }),
}));

jest.mock("../../../../../utils/useAuthFetch", () => ({
  useAuthFetch: () => jest.fn(),
}));

describe("FieldsStep user identifier", () => {
  beforeEach(() => {
    mockUpdateField.mockClear();
  });

  it("marks a field as the user identifier and unmarks the previous one", () => {
    mockSelectedFields = [
      mockSelected("f1", "email", true),
      mockSelected("f2", "work_email", false),
    ];
    render(<FieldsStep workspaceId="ws" />);

    const buttons = screen.getAllByRole("button", { name: "User identifier" });
    expect(buttons[0]).toHaveAttribute("aria-pressed", "true");
    expect(buttons[1]).toHaveAttribute("aria-pressed", "false");

    fireEvent.click(buttons[1]);

    expect(mockUpdateField).toHaveBeenNthCalledWith(1, "f1", {
      isUserIdentifier: false,
    });
    expect(mockUpdateField).toHaveBeenNthCalledWith(2, "f2", {
      isUserIdentifier: true,
    });
  });

  it("clears the marker when the marked field is toggled off", () => {
    mockSelectedFields = [mockSelected("f1", "email", true)];
    render(<FieldsStep workspaceId="ws" />);

    fireEvent.click(screen.getByRole("button", { name: "User identifier" }));

    expect(mockUpdateField).toHaveBeenCalledTimes(1);
    expect(mockUpdateField).toHaveBeenCalledWith("f1", {
      isUserIdentifier: false,
    });
  });
});
